import AxiosInstance from "./api";

export const SubsidiaryLedgerFCPaymentService = {
  getPaginate: async (params) => {
    return await AxiosInstance.get("/private/subsidiary-ledger-fc-payments/paginate", { params });
  },

  getById: async (id) => {
    return await AxiosInstance.get(`/private/subsidiary-ledger-fc-payments/${id}`);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/subsidiary-ledger-fc-payments", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/subsidiary-ledger-fc-payments/${id}`, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete(`/private/subsidiary-ledger-fc-payments/${id}`);
  },
};
